import React, { useState, useEffect } from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import { useParams, useSearchParams } from 'react-router-dom';
import { formatLocalDateTime } from '../utils/dateTime';
import { LoadingIndicator } from '../components/assets';

const PublicImage = () => {
  const { user_name, image_id } = useParams();
  const [searchParams] = useSearchParams();
  const share = searchParams.get('share');

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [imageData, setImageData] = useState(null);

  useEffect(() => {
    if (!share) {
      setError('Invalid share link.');
      setLoading(false);
      return;
    }

    fetch(`/api/public/images/${user_name}/${image_id}?share=${share}`)
      .then(res => res.json())
      .then(data => {
        if (data.error) {
          setError(data.error);
        } else {
          setImageData(data);
        }
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to load image.');
        setLoading(false);
      });
  }, [user_name, image_id, share]);

  const handleDownload = () => {
    if (!imageData?.image_url) return;
    const a = document.createElement('a');
    a.href = imageData.image_url;
    a.download = `${imageData.image_class || 'image'}_${user_name}.png`;
    a.click();
  };

  if (loading) {
    return (
      <Container maxWidth="md" sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <LoadingIndicator text="Loading image..." />
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="md" sx={{ mt: 4, textAlign: 'center' }}>
        <Typography variant="h5" color="error">
          {error}
        </Typography>
      </Container>
    );
  }

  return (
    <Box maxWidth="md" sx={{ mt: 4, textAlign: 'center' }}>
      <Typography variant="h4" gutterBottom>
        Dopatized Reward Earned by {user_name}
      </Typography>
      <Box sx={{ mb: 2 }}>
        <img
          src={imageData.image_url}
          alt={imageData.image_class || 'Shared image'}
          style={{ width: '100%', height: 'auto', borderRadius: 8, border: `2px solid`, borderColor: 'secondary.main' }}
        />
      </Box>
      <Typography variant="body2" sx={{ mb: 2 }}>
        {imageData.image_class && `Reward: ${imageData.image_class}`}
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        Generated on: {formatLocalDateTime(imageData.generated_at)}
      </Typography>
      <Button variant="contained" color="primary" onClick={handleDownload}>
        Download Image
      </Button>
    </Box>
    
  );
};

export default PublicImage;
